import { RouteConfig } from 'vue-router'

const routes: RouteConfig[] = [
  {
    path: 'sentstatus',
    component: () => import(/* webpackChunkName: "sentstatus" */ '@sentstatus/Index.vue')
  },
]
export default routes
